<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-02 22:34:36
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-02 22:34:36
-->
<template>
  <div class="CourseDetail">
    <SearchHeader />
    <h1>{{ data.name }}</h1>
    <div class="sub-title">
      发表时间：{{ data.createTime }} &nbsp;&nbsp;来源：{{
        data.copyFrom
      }}
      &nbsp;&nbsp;来源：{{
        data.curriculumType == 0
          ? "公开课"
          : data.curriculumType == 1
          ? "精品课"
          : "认证课"
      }}
    </div>
    <div>
      <div class="video-box">
        <video :src="data.videoId" controls />
      </div>
    </div>
    <div class="html-cotent" v-html="data.content"></div>
  </div>
</template>
<script>
import request from "../util/request";
export default {
  name: "course-detail",

  data() {
    return {
      data: {},
      title: "宁夏课程详情",
      time: "2017-12-20 10:22:23",
      source: "宁夏课程详情",
      videoUrl: "",
      html: "<div>12332313123131</div",
    };
  },
  mounted() {
    let id = this.$route.query.id;
    let curriculumType = this.$route.query.curriculumType;
    console.log(id);
    console.log(curriculumType);
    this.querDetail(id,curriculumType);
  },
  methods: {
    querDetail(id,curriculumType) {
      let url="";
      if(curriculumType==0){
        url="/api/client/common/curriculum/getPublicView/" + id;
      }else{
        url="/api/client/common/curriculum/getJjingpinView/" + id;
         let token = localStorage.getItem("token");
       if (token == null) {
          this.$router.push({
            path: "/login",
            query: { url: location.hash },
          });
        }
      }
      request({
        url: url,
        method: "get",
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data;
        } else if (res.code == "800") {
          this.$message.warning(res.msg);
        } 
      });
    },
  },
};
</script>
<style lang="less">
.CourseDetail {
  width: 1280px;
  margin: 20px auto;
  min-height: 800px;
  background: #fff;
  h1 {
    text-align: center;
    padding: 20px;
  }
  .sub-title {
    color: #999;
    font-size: 13px;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }
  .video-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    video {
      width: 600px;
      height: 400px;
      object-fit: contain;
    }
  }
  .html-cotent {
    width: 800px;
    margin: 40px auto;
    height: fit-content;
  }
}
</style>
